import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { OldButton } from "@kit/design/old-button"
import { Expander } from "app/regions/blocks/shared/expander"
import { BackgroundColor } from "../../components/background-color"
import Label from "@kit/design/label"
import { ColorInput } from "@kit/design/color-picker"
import Input from "@kit/design/input"
import Stack from "@kit/design/stack"
import { VisuallyHidden } from "@kit/design/visually-hidden"
import { BorderSettings } from "../../components/border-settings"
import { useSavedColors } from "hooks/use-saved-colors"

export function NavigationSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()

  const handleRemove = index => {
    update({ items: properties.items.filter((_, i) => i !== index) })
  }

  const handleAddLink = () => {
    update({ items: properties.items.concat({ text: "", url: "" }) })
  }

  const updateField = (event, index, field) => {
    const newItems = properties.items.map((item, i) => {
      if (i === index) {
        return { ...item, [field]: event.target.value }
      }
      return item
    })
    update({ items: newItems })
  }

  return (
    <Stack spacing={4}>
      <Stack spacing={6}>
        {properties.items.map((item, index) => (
          <Stack spacing={2} key={index}>
            <div className="flex justify-between">
              <Label htmlFor="text">Link #{index + 1}</Label>
              <OldButton size="sm" onClick={() => handleRemove(index)}>
                Remove
              </OldButton>
            </div>
            <div>
              <VisuallyHidden>
                <Label htmlFor="text">Text</Label>
              </VisuallyHidden>
              <Input
                className="text-gray-700 mb-1 w-full"
                placeholder="Text"
                name="link url"
                onChange={e => updateField(e, index, "text")}
                value={item.text || ""}
              />
            </div>
            <div>
              <VisuallyHidden>
                <Label htmlFor="text">Text</Label>
              </VisuallyHidden>
              <Input
                className="text-gray-700 mb-1 w-full"
                placeholder="URL"
                name="link url"
                onChange={e => updateField(e, index, "url")}
                value={item.url || ""}
              />
            </div>
          </Stack>
        ))}
        <OldButton is="secondary" className="w-full" onClick={handleAddLink}>
          Add link
        </OldButton>
      </Stack>
      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />
        <div>
          <Label htmlFor="textColor">Text</Label>
          <ColorInput
            id="textColor"
            name="textColor"
            onChange={color => update({ textColor: color.hex })}
            value={properties.textColor}
            savedColors={savedColors}
          />
        </div>
      </Expander>
      <BorderSettings properties={properties} update={update} />
    </Stack>
  )
}
